import React from "react";
import { Grid, Typography, IconButton } from "@mui/material";
import { GridCard } from "components/atoms";
import { theme } from "themes/theme";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from "react-router-dom";
import { I18nTranslator } from "utils/i18n";
import { translations } from "utils/i18n";

interface IHeaderProps {}

export const DetailHeader = (props: IHeaderProps) => {
  const history = useHistory();

  return (
    <GridCard
      sx={{
        position: "fixed",
        display: "flex",
        zIndex: 999,
        alignItems: "center",
        justifyContent: "center",
        p: "20px",
        flex: 1,
        width: "calc(100% - 40px)",
      }}
    >
      <Grid container spacing={2} sx={{}} alignItems="center">
        <Grid
          item
          container
          sx={{ display: { xs: "none", sm: "flex" } }}
          sm={6}
          justifyContent="flex-start"
        >
          <img
            src={require("../assets/images/logo-primary.png")}
            alt={"scs-logo"}
            style={{ width: 80 }}
          />
        </Grid>
        <Grid
          item
          container
          sx={{ display: { xs: "none", sm: "flex" } }}
          sm={6}
          justifyContent="flex-end"
        >
          <IconButton
            sx={{ backgroundColor: theme.colors.error.main }}
            onClick={() => {
              history.length > 1 ? history.go(-1) : history.replace("/");
            }}
          >
            <CloseIcon sx={{ color: "white" }} fontSize={"small"} />
            <Typography
              sx={{ paddingLeft: "6px", color: "white" }}
              fontWeight={"500"}
            >
              {I18nTranslator(translations.button.close)}
            </Typography>
          </IconButton>
        </Grid>
      </Grid>
    </GridCard>
  );
};
